import FontFaceObserver from 'fontfaceobserver';

var load = function load(fontFamily, parametrizedFamily) {
  var html = document.documentElement;
  var font = new FontFaceObserver(fontFamily);
  font.load().then(function () {
    html.classList.add(parametrizedFamily);
    sessionStorage.setItem(parametrizedFamily, true);
  })["catch"](function () {
    sessionStorage.setItem(parametrizedFamily, false);
  });
};

export default {
  load: load
};